import React, { useState } from "react";
import { Button, Modal } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";

import { isMessagingGlobalHeaderRevampEnable } from "MessagingV2/modules/Utils";
import PreviewChatWithOptions from "./PreviewChatWithOptions";
import classes from "./PreviewChatModal.scss";

const styles = {
  modalBodyStyle: {
    padding: "16px 32px 32px 32px",
    overflow: "hidden",
  },
  nextButtonStyle: { height: "48px", padding: "12px 16px" },
};

const PreviewChatModal = props => {
  const {
    onClose,
    onBackClick,
    onClickNext,
    selectedState = {},
    setSelectedState,
    chatId,
  } = props;

  const { t } = useI18n(["common"]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const handleNext = async () => {
    setIsButtonDisabled(true);
    const success = await onClickNext();
    if (!success) {
      setIsButtonDisabled(false);
    }
  };
  return (
    <Modal
      height="680px"
      width="700px"
      onClose={onClose}
      isOpen
      footerSeparator
    >
      <Modal.Header
        title={t("common:include_conversation_history")}
        subtitle={t("common:select_past_messages_and_files_to_move")}
        isClosable
        hasSeparator
      />

      <Modal.Body isScrollable style={styles.modalBodyStyle}>
        <PreviewChatWithOptions
          selectedState={selectedState}
          setSelectedState={setSelectedState}
          chatId={chatId}
        />
      </Modal.Body>
      <Modal.Footer hasSeparator>
        <div className={classes.footerContainer}>
          <Button variant="outlined-subtle" size="large" onClick={onBackClick}>
            {t("common:back")}
          </Button>
          <Button
            variant="progressive"
            size="large"
            disabled={isButtonDisabled}
            onClick={handleNext}
            {...(isMessagingGlobalHeaderRevampEnable()
              ? {
                  styles: styles.nextButtonStyle,
                  dsVersion: "2.0",
                  shortcut: { code: "Enter", shiftKey: true },
                }
              : {})}
          >
            {t("common:continue")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default PreviewChatModal;
